export default __webpack_public_path__ + "static/media/bellring.ec03ebcc.wav";